module.exports = __webpack_public_path__ + "img/7.e6146895.jpg";